import React from "react";

interface QuadrilateralProps {
  a?: string | number;
  b?: string | number;
  foldType?: string;
  foldDirection?: number;
  arrowColor?: string;
  textColor?: string;
}

const Quadrilateral: React.FC<QuadrilateralProps> = ({
  a = "",
  b = "",
  foldType = "",
  foldDirection = 1,
  arrowColor = "#1E8F31",
  textColor = "#000"
}) => {
  return (
    <svg
      width="210"
      height="210"
      viewBox="-30 0 218 188"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Rectangle / Square */}
      <rect
        x="42"
        y="42"
        width="142"
        height="142"
        stroke="#1E8F31"
        strokeWidth="3"
      />

      {/* Arrows */}
      <path
        d="M21 38L17.5359 44L24.4641 44L21 38ZM21 188L24.4641 182L17.5359 182L21 188ZM20.4 43.4L20.4 182.6L21.6 182.6L21.6 43.4L20.4 43.4Z"
        fill={arrowColor}
      />
      <path
        d="M38 19L44 22.4641V15.5359L38 19ZM188 19L182 15.5359V22.4641L188 19ZM43.4 19.6H182.6V18.4H43.4V19.6Z"
        fill={arrowColor}
      />

      {/* Letters */}
      <text
        xmlSpace="preserve"
        textAnchor="end"
        fontFamily="Roboto"
        fontSize="12"
        y="113.30221"
        x="17.90755"
        fill={textColor}
      >
        A: {a}
      </text>
      <text
        xmlSpace="preserve"
        textAnchor="middle"
        fontFamily="Roboto"
        fontSize="12"
        y="13.55862"
        x="109.34874"
        fill={textColor}
      >
        B: {b}
      </text>

      {/* Bi Fold V */}
      {foldType === "Bi-Fold" && foldDirection === 2 && (
        <line
          x1="113.6"
          y1="46"
          x2="113.6"
          y2="180"
          stroke="#1E8F31"
          strokeWidth="1.2"
          strokeDasharray="6 6"
        />
      )}

      {/* Tri Fold V */}
      {foldType === "Tri-Fold" && foldDirection === 2 && (
        <>
          <line
            x1="89.6"
            y1="46"
            x2="89.6"
            y2="180"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="137.6"
            y1="46"
            x2="137.6"
            y2="180"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Quad Fold V */}
      {foldType === "Quad-Fold" && foldDirection === 2 && (
        <>
          <line
            x1="113.6"
            y1="46"
            x2="113.6"
            y2="180"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="76.6"
            y1="46"
            x2="76.6"
            y2="180"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="148.6"
            y1="46"
            x2="148.6"
            y2="180"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Five Fold V */}
      {foldType === "Five-Fold" && foldDirection === 2 && (
        <>
          <line
            x1="72.8"
            y1="48"
            x2="72.8"
            y2="182"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="100"
            y1="48"
            x2="100"
            y2="182"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="127.2"
            y1="48"
            x2="127.2"
            y2="182"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="154.4"
            y1="48"
            x2="154.4"
            y2="182"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Six Fold V */}
      {foldType === "Six-Fold" && foldDirection === 2 && (
        <>
          <line
            x1="67.266"
            y1="45"
            x2="67.266"
            y2="182"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="89.9367"
            y1="45"
            x2="89.9367"
            y2="182"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="112.607"
            y1="45"
            x2="112.607"
            y2="182"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="135.276"
            y1="45"
            x2="135.276"
            y2="182"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="157.94"
            y1="45"
            x2="157.94"
            y2="182"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Bi Fold H */}
      {foldType === "Bi-Fold" && foldDirection === 1 && (
        <line
          x1="46"
          y1="112.4"
          x2="180"
          y2="112.4"
          stroke="#1E8F31"
          strokeWidth="1.2"
          strokeDasharray="6 6"
        />
      )}

      {/* Tri Fold H */}
      {foldType === "Tri-Fold" && foldDirection === 1 && (
        <>
          <line
            x1="46"
            y1="89.4"
            x2="180"
            y2="89.4"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="46"
            y1="136.4"
            x2="180"
            y2="136.4"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Quad Fold H */}
      {foldType === "Quad-Fold" && foldDirection === 1 && (
        <>
          <line
            x1="46"
            y1="112.4"
            x2="180"
            y2="112.4"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="46"
            y1="76.4"
            x2="180"
            y2="76.4"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="46"
            y1="149.4"
            x2="180"
            y2="149.4"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Five Fold H */}
      {foldType === "Five-Fold" && foldDirection === 1 && (
        <>
          <line
            x1="46"
            y1="74.6"
            x2="183"
            y2="74.6"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="46"
            y1="101.8"
            x2="183"
            y2="101.8"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="46"
            y1="129"
            x2="183"
            y2="129"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="46"
            y1="156.2"
            x2="183"
            y2="156.2"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}

      {/* Six Fold H */}
      {foldType === "Six-Fold" && foldDirection === 1 && (
        <>
          <line
            x1="46"
            y1="67.0666"
            x2="183"
            y2="67.0666"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="46"
            y1="89.736"
            x2="183"
            y2="89.736"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="46"
            y1="112.406"
            x2="183"
            y2="112.406"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="46"
            y1="135.077"
            x2="183"
            y2="135.077"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
          <line
            x1="46"
            y1="157.747"
            x2="183"
            y2="157.747"
            stroke="#1E8F31"
            strokeWidth="1.2"
            strokeDasharray="6 6"
          />
        </>
      )}
    </svg>
  );
};

export default Quadrilateral;

